import { createFileRoute } from '@tanstack/react-router'
import ModalMessage from 'components/modal-message';
import SuccessIcon from '../../../assets/images/Success';
import { useContext, useEffect, useState } from 'react';
import { ElectronicSignatureContext } from '../../-src/context/electronic-signature.context';
import { savePersonData } from '../../-src/actions/person-data.action';
import { saveApplicationData } from '../../-src/actions/application-data.action';
import { getApplicationDataSessionStorage } from '../../-src/services/session-storage.service';

export const Route = createFileRoute('/_with-appbar/ok/')({
  component: RouteComponent,
})

function RouteComponent() {
const {dispatch:{personDataDispatch, applicationDataDispatch}} = useContext(ElectronicSignatureContext);
const [solictudValue, setSolicitudValue] = useState("");
const applicationSessionData = getApplicationDataSessionStorage();


  useEffect(()=>{
    if(applicationSessionData?.solicitudeNumber){
      setSolicitudValue(applicationSessionData?.solicitudeNumber)
    }
    sessionStorage.clear();
    personDataDispatch(savePersonData({documentNumber:"", documentType: 0, uniqueId: "", signatoryType: 0}));
    applicationDataDispatch(saveApplicationData({tokenSesion: "", codigoAplicacion: 0, idSolicitud: 0}));
  },[])

  return <div className='flex flex-col gap-10 items-center justify-center h-screen '>
    <ModalMessage isOpen={true} title="¡Tu identidad fue verificada con éxito!" messageBody="Hemos finalizado el proceso correctamente, pronto recibirás un correo por tu compra." 
      iconElement={<SuccessIcon />} solicitudeNumber={solictudValue} />
  </div>
}
